import React from 'react';
import { PropTypes } from 'prop-types';
import SubmissionCard from './SubmissionCard';

const SubmissionsPageResults = ({ submissions, context }) => {
  if (!submissions || submissions.length === 0) {
    return (
      <p data-testid="submissions-table-fetcher-empty">
        No form submissions found
      </p>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <ul
      data-testid="submissions-card"
      className="submissions__list"
      sort-column={1}
      role="list"
    >
      {submissions.map((submission, index) => {
        return (
          <SubmissionCard
            context={context}
            submission={submission}
            key={index}
          />
        );
      })}
    </ul>
  );
};

SubmissionsPageResults.propTypes = {
  context: PropTypes.string,
  submissions: PropTypes.arrayOf(
    PropTypes.shape({
      length: PropTypes.number,
      map: PropTypes.func,
    }),
  ),
};

SubmissionsPageResults.defaultProps = {
  context: null,
};

export default SubmissionsPageResults;
